import { render, staticRenderFns } from "./Specialities.vue?vue&type=template&id=7960ebb3&scoped=true"
import script from "./Specialities.vue?vue&type=script&lang=ts"
export * from "./Specialities.vue?vue&type=script&lang=ts"
import style0 from "./Specialities.vue?vue&type=style&index=0&id=7960ebb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7960ebb3",
  null
  
)

export default component.exports